import { Action } from '@ngrx/store';
import { Order, IJobsiteSalesArea } from '@cemex-core/cmx-api';

export enum OneClickJobsiteSalesAreaActionTypes {
  LOAD_JOBSITE_SALES_AREA = '[One Click] Load jobsite sales area',
  LOAD_JOBSITE_SALES_AREA_COMPLETE = '[One Click] Load jobsite sales area completed',
  RESET = '[One Click] jobsite sales area reset',
  MANDATORY = '[One Click] purchase order validation',
  LOAD_ERROR = '[One Click] Error load jobsite sales area',
  SALES_AREA_ERROR = '[One Click] Error no sales area',
  VALIDATE_START = '[One Click] Start validate PO',
  VALIDATE_END = '[One Click] End validate PO',
}

export class OneClickLoadJobsiteSalesAreaAction implements Action {
  readonly type = OneClickJobsiteSalesAreaActionTypes.LOAD_JOBSITE_SALES_AREA;

  constructor(public payload: Order) {}
}

export class OneClickLoadJobsiteSalesAreaCompleteAction implements Action {
  readonly type = OneClickJobsiteSalesAreaActionTypes.LOAD_JOBSITE_SALES_AREA_COMPLETE;

  constructor(public payload: IJobsiteSalesArea[]) {}
}

export class OneClickResetJobsiteSalesAreaAction implements Action {
  readonly type = OneClickJobsiteSalesAreaActionTypes.RESET;

  constructor() {}
}

export class OneClickErrorLoadJobsiteSalesAreaAction implements Action {
  readonly type = OneClickJobsiteSalesAreaActionTypes.LOAD_ERROR;

  constructor(public payload: any) {}
}

// TODO: WIP
export class OneClickErrorNoSalesArea implements Action {
  readonly type = OneClickJobsiteSalesAreaActionTypes.SALES_AREA_ERROR;

  constructor() {}
}

export class OneClickPurchaseOrderValidation implements Action {
  readonly type = OneClickJobsiteSalesAreaActionTypes.MANDATORY;

  constructor(public payload: boolean) {}
}

export class OneClickPurchaseOrderValidateStartAction implements Action {
  readonly type = OneClickJobsiteSalesAreaActionTypes.VALIDATE_START;

  constructor() {}
}

export class OneClickPurchaseOrderValidateEndAction implements Action {
  readonly type = OneClickJobsiteSalesAreaActionTypes.VALIDATE_END;

  constructor() {}
}

export type OneClickJobsiteSalesAreaActions =
  | OneClickLoadJobsiteSalesAreaAction
  | OneClickLoadJobsiteSalesAreaCompleteAction
  | OneClickPurchaseOrderValidation
  | OneClickResetJobsiteSalesAreaAction
  | OneClickErrorLoadJobsiteSalesAreaAction
  | OneClickPurchaseOrderValidateStartAction
  | OneClickPurchaseOrderValidateEndAction;
